import React from "react";
import { makeStyles } from "@material-ui/core";
import CardDownload from './cardDownload';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        flexDirection: 'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        maxWidth: '100%',
     
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',
    },
    gridTitle: {
        position: 'relative',
        marginTop: 100,
    },
    title: {
        fontSize: 28,
        marginBottom: 75,
        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    gridDownload: {
        width: '35%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        minWidth:650,
        '@media (max-width:750px)': {
            textAlign: 'center',
            justifyContent: 'center',
            flexDirection:'column',
            minWidth:'100%',
        },
    }
}))


export default function Index() {

    let classes = useStyles();

    let data = [
        {
            title: 'فرم اشخاص حقیقی',
            icon: "/assets/icons/kala/userDoc.svg",
            link: '/assets/file/kala/فرم درخواست صدور کد شخص حقیقی.pdf',
        },
        {
            title: 'فرم اشخاص حقوقی',
            icon: "/assets/icons/kala/homeTwo.svg ",
            link: '/assets/file/kala/فرم درخواست صدور کد شخص حقوقی.pdf',
        },
    ]

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    دانلود فرم‌های کدگیری بورس کالا
                </h3>
            </div>
            <div className={classes['gridDownload']}>
                {
                    data?.map((item, index) => {
                        return (
                            <CardDownload data={item} key={index} />

                        )
                    })
                }
            </div>
        </div>)
}

